module.exports = __webpack_public_path__ + "img/account-setting.5eb7baf0.svg";